"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hashRundownRows = exports.rundownRowSortFn = void 0;
/*
utility to generate a checksum from the rows of a rundown that are meaningful enough to
allow the client and server to stay in sync with delta updates.

The checksum needs to take into account any fields that are editable in a rundown and
also reflect the ordering of rows, but does NOT need to include the exact sequence. So,
we sort by sequence and then omit the field from the checksum to allow the client and
server to be "in sync ENOUGH" with independent implementations of reordering rows
*/
const jsum_1 = __importDefault(require("jsum"));
// deterministic sorter of rundown rows. Use ID as a tiebreaker if
// the sequences are equal
const rundownRowSortFn = (a, b) => {
    if (a.sequence !== b.sequence) {
        return a.sequence - b.sequence;
    }
    return a.id - b.id;
};
exports.rundownRowSortFn = rundownRowSortFn;
const hashRundownRows = (rows) => {
    // put the rows in order by sequence
    const sortedRows = [...rows].sort(exports.rundownRowSortFn);
    // remove the sequence and any extra fields passed in at runtime
    const hashInput = sortedRows.map(({ id, rowTypeId, rundownId, linkedScriptId, identityScriptId, blockId, blobData, }) => ({
        id,
        rowTypeId,
        rundownId,
        linkedScriptId,
        identityScriptId,
        blockId,
        blobData,
    }));
    return jsum_1.default.digest(hashInput, 'sha256', 'hex');
};
exports.hashRundownRows = hashRundownRows;
